import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ChartComponent } from '@app/shared/components/chart/base-chart/chart.component';
import { ChartData, ChartOptions } from 'node_modules/chart.js/dist/types';
import { zoomControlsPlugin } from '@app/core/services/charts/plugins/zoom-controls.plugin';
import { hoverVerticalLinePlugin } from '@app/core/services/charts/plugins/hover-vertical-line.plugin';
import { scrollPanPlugin } from '@app/core/services/charts/plugins/scroll-pan.plugin';

@Component({
  selector: 'gc-floating-popup-line-chart-wrapper',
  imports: [ChartComponent],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './floating-popup-line-chart-wrapper.component.html',
  styleUrl: './floating-popup-line-chart-wrapper.component.scss',
  host: {
    class: 'flex flex-col',
  },
})
export class FloatingPopupLineChartWrapperComponent {
  public chartData = input.required<ChartData | undefined>();
  public chartOptions = input.required<ChartOptions | undefined>();

  public chartPlugins = [hoverVerticalLinePlugin, zoomControlsPlugin, scrollPanPlugin];
}
